module.exports = __webpack_public_path__ + "static/media/whiteTick.03ad7f2f.svg";